/**
 * Vrai pour une requête de fichier statique servi par l'application elle-même
 * (fichiers de traduction, images…).
 *
 * @param url URL de la requête, telle que posée par l'appelant.
 *
 * @remarks
 * Ces requêtes doivent **traverser la chaîne d'intercepteurs sans y toucher à la session** : un
 * fichier statique n'a pas besoin de jeton, et surtout le premier d'entre eux — le fichier de
 * langue — est chargé par l'initialiseur d'application, avant tout le reste. Y injecter
 * `AuthService` depuis un intercepteur le fait construire à ce moment-là, et toute requête émise
 * par sa construction rappelle l'intercepteur, donc `AuthService` : c'est la dépendance circulaire
 * NG0200 rencontrée le 2026-08-25.
 */
export function isStaticAsset(url: string): boolean {
  return url.startsWith('assets/') || url.startsWith('/assets/');
}
